export { default as isNumberKey } from './isNumberKey';
